import React, { Component } from 'react';
import Family from '../HocComponent';

// Member details for Parent (Adult)
const memberDetails = {
    type: 'adult',
    myage: '38years',
    rashi: 'kumbh'
};

/**
 * Parent family member component - represents an adult
 * Enhanced by the Family HOC with age management and modal functionality
 */
class ParentHoc extends Component {
    render() {
        const { mydetail, age, incrementAge } = this.props;
        const details = { ...mydetail };

        return (
            <div className="family-member">
                <div className="py-4">
                    <div className="justify-content-center">
                        <div className="">
                            <div className="card">
                                <div className="card-header text-left">
                                    <h1 className="card-title mb-1">
                                        <i className="fas fa-user-tie mr-2"></i>
                                        Parent Profile
                                    </h1>
                                    <small className="text-light">Adult Family Member</small>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-8 text-left">
                                            <div className="profile-section mb-4">
                                                <div className="profile-avatar mb-3">
                                                    <div className="avatar-circle bg-primary text-white d-inline-flex align-items-center justify-content-center">
                                                        <i className="fas fa-user fa-2x"></i>
                                                    </div>
                                                </div>
                                                <h2 className="text-dark">My name is Parent</h2>
                                                <h3 className="text-muted">Current Age: <span className="badge badge-primary badge-lg">{age}</span></h3>
                                            </div>

                                            <div className="action-section mb-4">
                                                <button
                                                    onClick={incrementAge}
                                                    className="btn btn-primary btn-lg px-4"
                                                    type="button"
                                                    aria-label={`Increment Parent's age, currently ${age}`}
                                                >
                                                    <i className="fas fa-plus-circle mr-2"></i>
                                                    Increment Age: {age}
                                                </button>
                                            </div>

                                            <h3 className="text-primary mt-4 mb-3">Professional Details</h3>
                                            <p className="lead">
                                                As the adult member of the family, Parent represents maturity and responsibility.
                                                This component demonstrates professional UI patterns with clean card-based design
                                                and structured information display.
                                            </p>

                                            <h4 className="text-primary mt-4 mb-3">Key Characteristics</h4>
                                            <ul className="list-unstyled">
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success mr-2"></i>
                                                    Professional card-based interface design
                                                </li>
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success mr-2"></i>
                                                    Clean typography and spacing
                                                </li>
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success mr-2"></i>
                                                    Structured information display
                                                </li>
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success mr-2"></i>
                                                    Enhanced by Family HOC pattern
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="bg-light p-4 rounded">
                                                <h3 className="text-primary mb-3">
                                                    <i className="fas fa-info-circle mr-2"></i>
                                                    Member Details
                                                </h3>
                                                <div className="member-details">
                                                    <div className="detail-item mb-3 p-3 bg-white rounded">
                                                        <h4 className="h5 mb-1">
                                                            <i className="fas fa-tag text-primary mr-2"></i>
                                                            Type
                                                        </h4>
                                                        <span className="text-dark text-capitalize">{details.type}</span>
                                                    </div>
                                                    <div className="detail-item mb-3 p-3 bg-white rounded">
                                                        <h4 className="h5 mb-1">
                                                            <i className="fas fa-birthday-cake text-primary mr-2"></i>
                                                            Age Category
                                                        </h4>
                                                        <span className="text-dark">{details.myage}</span>
                                                    </div>
                                                    <div className="detail-item mb-3 p-3 bg-white rounded">
                                                        <h4 className="h5 mb-1">
                                                            <i className="fas fa-star text-primary mr-2"></i>
                                                            Rashi
                                                        </h4>
                                                        <span className="text-dark text-capitalize">{details.rashi}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-5 text-left">
                                        <h3 className="text-primary mb-3">HOC Enhancement Features</h3>
                                        <p>
                                            This Parent component is enhanced by the Family Higher-Order Component,
                                            which provides shared functionality while maintaining individual characteristics.
                                        </p>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="feature-card p-3 border rounded mb-3">
                                                    <h4 className="h5 text-primary">
                                                        <i className="fas fa-cogs mr-2"></i>
                                                        Age Management
                                                    </h4>
                                                    <p className="mb-0 text-muted">
                                                        Shared age tracking and increment functionality across all family members.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="feature-card p-3 border rounded mb-3">
                                                    <h4 className="h5 text-primary">
                                                        <i className="fas fa-window-restore mr-2"></i>
                                                        Modal Integration
                                                    </h4>
                                                    <p className="mb-0 text-muted">
                                                        Enhanced modal controls with accessibility features and smooth animations.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="feature-card p-3 border rounded mb-3">
                                                    <h4 className="h5 text-primary">
                                                        <i className="fas fa-users mr-2"></i>
                                                        Family Pattern
                                                    </h4>
                                                    <p className="mb-0 text-muted">
                                                        Demonstrates HOC pattern with shared props and individual customization.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Set display name for debugging
ParentHoc.displayName = 'ParentHoc';

export default Family(ParentHoc, memberDetails);